import { Discovery } from '@or-sdk/discovery';
import { ref, watch, computed } from 'vue-demi';
import { createSharedComposable } from '@vueuse/core';
import { Settings } from '@or-sdk/settings';
import { S as SERVICES } from './services-8eb03020.js';

function useServiceDiscoveryUiServices(token, config, feature) {
  const getDiscoveryUiServices = ref(() => Promise.resolve([]));
  const state = ref(null);
  watch(token, val => {
    if (!(val === null || val === void 0 ? void 0 : val.length)) return;
    const instance = new Discovery({
      token: val,
      ...config
    });
    getDiscoveryUiServices.value = () => instance.listServices({
      type: 'ui',
      feature
    }).then(res => res.items);
  }, {
    immediate: true
  });
  const getUiServices = computed(() => {
    if (!Array.isArray(state.value) || state.value.length === 0) {
      getDiscoveryUiServices.value().then(services => {
        if (services === null || services === void 0 ? void 0 : services.length) state.value = services || [];
      });
    }
    return state.value;
  });
  return {
    getUiServices
  };
}
var useServiceDiscoveryUiServices$1 = createSharedComposable(useServiceDiscoveryUiServices);

const USER_SERVICE_NAVIGATION_SETTINGS_URL = 'service-navigation';
const FAVORITES = 'favorites';

function useUserServiceNavigationSettings(token, config, key) {
  const getUserServiceNavigationSettings = ref(() => Promise.resolve(null));
  const setUserServiceNavigationSettings = ref(data => Promise.resolve());
  watch(token, val => {
    if (val === null || val === void 0 ? void 0 : val.length) {
      const instance = new Settings({
        token: val,
        ...config
      });
      getUserServiceNavigationSettings.value = function () {
        return instance.getUserSettings({
          key: makePath(key)
        });
      };
      setUserServiceNavigationSettings.value = function (data) {
        return instance.setUserSettings({
          key: makePath(key),
          value: data
        });
      };
    }
    // immediate: true; because in some cases token already exist, and it will not change his value
  }, {
    immediate: true
  });
  const makePath = part => (part === null || part === void 0 ? void 0 : part.length) ? `${USER_SERVICE_NAVIGATION_SETTINGS_URL}.${part}` : USER_SERVICE_NAVIGATION_SETTINGS_URL;
  return {
    getUserServiceNavigationSettings,
    setUserServiceNavigationSettings
  };
}
var useUserServiceNavigationSettings$1 = createSharedComposable(useUserServiceNavigationSettings);

function useUserServiceNavigationFavoritesServicesSettings(token, config) {
  const state = ref(null);
  const {
    getUserServiceNavigationSettings,
    setUserServiceNavigationSettings
  } = useUserServiceNavigationSettings$1(token, config, FAVORITES);
  const getUserFavoritesServices = computed({
    get() {
      if (!Array.isArray(state.value)) {
        getUserServiceNavigationSettings.value().then(fs => {
          if (fs === null || fs === void 0 ? void 0 : fs.length) {
            if (Object.keys(SERVICES).some(key => fs.includes(key))) {
              // fixing deprecated keys
              state.value = fs === null || fs === void 0 ? void 0 : fs.map(key => {
                var _a;
                return (_a = SERVICES[key]) !== null && _a !== void 0 ? _a : key;
              });
              setUserServiceNavigationSettings.value(state.value);
            } else {
              state.value = fs || [];
            }
          }
        });
      }
      return state.value;
    },
    set(data) {
      var _a;
      state.value = (_a = data === null || data === void 0 ? void 0 : data.map(key => {
        var _a;
        return (_a = SERVICES[key]) !== null && _a !== void 0 ? _a : key;
      })) !== null && _a !== void 0 ? _a : null;
    }
  });
  const addToUserFavoritesServices = item => {
    if (item) {
      const value = getUserFavoritesServices.value || [];
      getUserFavoritesServices.value = [...value, item];
      setUserServiceNavigationSettings.value(getUserFavoritesServices.value);
    }
  };
  const removeFromUserFavoritesServices = item => {
    if (item) {
      getUserFavoritesServices.value = (getUserFavoritesServices.value || []).filter(i => i !== item);
      setUserServiceNavigationSettings.value(getUserFavoritesServices.value);
    }
  };
  const toggleUserFavoritesServices = item => {
    (getUserFavoritesServices.value || []).indexOf(item) === -1 ? addToUserFavoritesServices(item) : removeFromUserFavoritesServices(item);
  };
  return {
    addToUserFavoritesServices,
    removeFromUserFavoritesServices,
    toggleUserFavoritesServices,
    getUserFavoritesServices
  };
}

export { useServiceDiscoveryUiServices$1 as a, useUserServiceNavigationFavoritesServicesSettings as u };
